// Live per-step progress list — "which tool is running, brief status", per the locked
// architecture decision that the raw internal plan JSON is never rendered. Mirrors the existing
// `ToolMessageRow` visual treatment for consistency with the old-backend message list.
import React from 'react';
import {CircularProgress, Stack, Typography} from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {getAgenticStepLabel} from '../constants/agenticStepLabels';

const STATUS_ICON = {
    running: <CircularProgress size={14} thickness={5} aria-label="Step in progress"/>,
    succeeded: <DoneRoundedIcon sx={{fontSize: 16, color: 'success.main'}} titleAccess="Step succeeded"/>,
    failed: <CloseRoundedIcon sx={{fontSize: 16, color: 'error.main'}} titleAccess="Step failed"/>,
};

/** @param {{steps: Array<{id: string, tool: string, status: string, error?: string}>}} props */
const AgenticStepList = ({steps = []}) => {
    if (!steps.length) {
        return null;
    }

    return (
        <Stack spacing={0.75}>
            {steps.map((step) => (
                <Stack key={step.id} direction="row" spacing={1} alignItems="center">
                    <Stack alignItems="center" justifyContent="center" sx={{minWidth: 16, height: 16}}>
                        {STATUS_ICON[step.status] || null}
                    </Stack>
                    <Typography variant="caption" color="text.secondary" sx={{fontWeight: 600}}>
                        {step.displayLabel || getAgenticStepLabel(step.tool) || step.id}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
};

export default AgenticStepList;
